import { Skeleton } from "antd";
import React from "react";

const OrderSkeleton = () => {
  return (
    <div
      className="order-section"
      style={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        overflow: "hidden",
        marginBottom: "16px",
      }}
    >
      <div
        className="order-summary"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px",
          borderBottom: "1px solid #eee",
        }}
      >
        <div style={{ flex: 1 }}>
          <Skeleton.Input active size="small" style={{ width: 100 }} />
          <div style={{ marginTop: 8 }}>
            <Skeleton.Input active size="small" style={{ width: 150 }} />
          </div>
          <div style={{ marginTop: 8 }}>
            <Skeleton.Input active size="small" style={{ width: 80 }} />
          </div>
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <Skeleton.Button active size="small" />
          <Skeleton.Button active size="small" />
        </div>
      </div>

      <div style={{ padding: "10px" }}>
        <div
          className="order-detail-item"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            gap: "10px",
            padding: "3px",
            backgroundColor: "#fafafa",
            borderRadius: "6px",
          }}
        >
          <div
            className="image-container"
            style={{
              width: "38%",
              minWidth: "100px",
              maxWidth: "180px",
              flexShrink: 0,
              position: "relative",
              aspectRatio: "1",
            }}
          >
            <Skeleton.Image
              active
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          </div>
          <div
            className="item-details"
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <Skeleton.Input active size="small" style={{ width: "80%" }} />
            <Skeleton.Input active size="small" style={{ width: "60%" }} />
            <Skeleton.Input active size="small" style={{ width: "40%" }} />
            <Skeleton.Input active size="small" style={{ width: "50%" }} />
            <Skeleton.Input active size="small" style={{ width: "30%" }} />
            <div style={{ marginTop: 8 }}>
              <Skeleton.Input active size="small" style={{ width: "70%" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSkeleton;
